import { render, staticRenderFns } from "./live-end.vue?vue&type=template&id=99d4bab8&scoped=true&"
import script from "./live-end.vue?vue&type=script&lang=js&"
export * from "./live-end.vue?vue&type=script&lang=js&"
import style0 from "./live-end.vue?vue&type=style&index=0&id=99d4bab8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d4bab8",
  null
  
)

export default component.exports